<template>
    <zen-message-modal :isOpen="isOpen" title="Remove rule?">
        Are you sure you want to remove this rule from this environment flag?
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script setup>
defineProps({
    isOpen: {
        type: Boolean,
        required: true,
    },
})

defineEmits(['close', 'confirm'])
</script>
